module.exports = __webpack_public_path__ + "img/undraw_Grades_re_j7d6.9ce13997.png";